import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useMemo } from 'react';
import algoliasearch from 'algoliasearch/lite';
import { createAutocomplete } from '@algolia/autocomplete-core';
import { getAlgoliaResults } from '@algolia/autocomplete-preset-algolia';
import insightsClient from 'search-insights';
import { createAlgoliaInsightsPlugin } from '@algolia/autocomplete-plugin-algolia-insights';
var defaultResultsParams = {
  hitsPerPage: 10,
  facetFilters: ["hidden:-true"],
  clickAnalytics: true
};

/**
 * A hook to manage autocomplete for Algolia
 * @returns An object containing the autocompleteState (AutocompleteState from Algolia) and the autocomplete (result of createAutocomplete from Algolia)
 */
var useAutocomplete = function useAutocomplete(_ref) {
  var placeholder = _ref.placeholder,
      insightsInitParams = _ref.insightsInitParams,
      appId = _ref.appId,
      apiKey = _ref.apiKey,
      searchOptions = _ref.searchOptions,
      indexName = _ref.indexName,
      _ref$resultsParams = _ref.resultsParams,
      resultsParams = _ref$resultsParams === void 0 ? defaultResultsParams : _ref$resultsParams,
      sourceId = _ref.sourceId;
  insightsClient("init", _objectSpread({
    useCookie: true
  }, insightsInitParams));
  var plugins = useMemo(function () {
    var insightsPlugin = createAlgoliaInsightsPlugin({
      insightsClient: insightsClient
    });
    return [insightsPlugin];
  }, []);

  var _useState = useState(),
      autocompleteState = _useState[0],
      setAutocompleteState = _useState[1];

  var searchClient = useMemo(function () {
    return algoliasearch(appId, apiKey, searchOptions);
  }, [apiKey, appId, searchOptions]);
  var autocomplete = useMemo(function () {
    return createAutocomplete({
      placeholder: placeholder,
      plugins: plugins,
      onStateChange: function onStateChange(_ref2) {
        var state = _ref2.state;
        setAutocompleteState(state);
      },
      getSources: function getSources() {
        return [{
          sourceId: sourceId,
          getItemInputValue: function getItemInputValue(_ref3) {
            var item = _ref3.item;
            return item.query;
          },
          getItems: function getItems(_ref4) {
            var query = _ref4.query;
            return getAlgoliaResults({
              searchClient: searchClient,
              queries: [{
                indexName: indexName,
                query: query,
                params: resultsParams
              }]
            });
          },
          getItemUrl: function getItemUrl(_ref5) {
            var item = _ref5.item;
            return item.url;
          }
        }];
      }
    });
  }, [indexName, placeholder, plugins, resultsParams, searchClient, sourceId]);
  return {
    autocompleteState: autocompleteState,
    autocomplete: autocomplete
  };
};

export default useAutocomplete;